import React from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { monetateDetailsAction } from '../middleware/monetateDetailsAction';
import useStateRef from 'react-usestateref';
import { miniCartDetailsAction } from '../middleware/miniCartDetailsAction';
 
function Monetate({ state }) {
    
     const isCartUpdate = useSelector(state => state.getUpdateMiniCartFlag);
    const miniCartDetailsFromRedux = useSelector(state => state.getMiniCartDetails)
    const monetateDetails = useSelector(state => state.getMonetateDetails.monetateDetails);
    const [count, setCount, countRef] = useStateRef(0);
    const [prevUrl, setPrevUrl, prevUrlRef] = useStateRef();
    const [pageType, setPageType, pageTypeRef] = useStateRef();
    const [prevPageType, setPrevPageType, prevPageTypeRef] = useStateRef();
    const [globalCartRows, setGlobalCartRows, globalCartRowsRef] = useStateRef({});
    const [tempMonetateDetails, setTempMonetateDetails, tempMonetateDetailsRef] = useStateRef('')
    const resourceCategoryPageTypes = ['Resources_Care', 'Resources_SDS' ];
    const teacherResourceProducts = ['tr49804.tr'];
    const dispatch = useDispatch();
 
    useEffect(()=>{
      
        console.log('state in monetate...',state);
        let url = window.location.href;
        window.monetateQ = window.monetateQ || [];
        console.log( 'miniCartDetails for monetate...' ,state?.miniCartDetails ? state?.miniCartDetails : "");
        var pageType = '';
        if(state?.monetateCategoryInfo){
             pageType = state?.monetateCategoryInfo?.pageType;
        }else if(state?.monetatePageType){
            pageType = state?.monetatePageType;
        }
        if(pageType){
            setPageType(pageType);
        }
 
        var minicartDetails = state?.miniCartDetails ? state?.miniCartDetails : "";
        console.log('minicartDetails??',minicartDetails);
        
        var cartItems = minicartDetails?.cartItems ? minicartDetails?.cartItems : '';
        console.log('cartItems in state...', cartItems);
        console.log('url check...',url === prevUrlRef.current);
        if(miniCartDetailsFromRedux?.miniCartDetails?.cartItems && url == prevUrlRef.current){
            cartItems = miniCartDetailsFromRedux?.miniCartDetails?.cartItems ? miniCartDetailsFromRedux?.miniCartDetails?.cartItems : [];
        }
 console.log('monetateDetails...outside',monetateDetails);
    console.log('cartItems...',cartItems);
    console.log('pageType...',pageType);
 
 
   var cartRows = [];
        if(cartItems){
     cartItems?.map((oneItem) => {
            var price = oneItem?.price;
            if(price){
                price =  price.replace('$','')
                price = price.replace(',','')
            }
            const temp = {
                productId: oneItem?.productId,
                       quantity:  oneItem?.quantity,
                       unitPrice: price,
                       sku: oneItem?.productId,
                        currency: "USD"}
                cartRows.push(temp);
     });}
       
     console.log('cartRows...',cartRows);
    //  if(resourceCategoryPageTypes.includes(pageType)){
    //     console.log('global monetate vanished...');
    //     dispatch(monetateDetailsAction({}))        
 
    // }
 
    
    console.log('url',url, 'prevUrl',prevUrl);
    if(url != prevUrlRef.current ){
    if((url.includes('.pr') ||  teacherResourceProducts.some(productId => url.includes(productId)))  && monetateDetails && monetateDetails?.addProductDetails  && monetateDetails?.setPageType && (monetateDetails?.setPageType).length > 0 && !deepEqual(monetateDetails, tempMonetateDetailsRef.current)){
            console.log('inside pdp section');
            console.log('monetateDetails...inside',monetateDetails);
            Object.entries(monetateDetails).forEach(([key, value]) => {
                if(key === "setPageType"){
                    console.log('valueeee',value);
                    console.log('valueeee[1]',value[1]);
 
                    pageType = value[1];
                    if(pageType){
                        setPageType(pageType);
                    }
                }
                console.log('pageType in pdp...', pageType);
                window.monetateQ.push(value);
            });
            window.monetateQ.push(["addCartRows", cartRows]);
            window.monetateQ.push(["setPageType", pageType]);
 
            window.monetateQ.push(["trackData"]);
            setGlobalCartRows(cartRows);
            setTempMonetateDetails(monetateDetails);
            setPrevUrl(url);
            setPrevPageType(pageType);
        
    }else if((pageType == 'Category_Product')&& monetateDetails && monetateDetails?.addProducts && (!url.includes('.pr') || url.includes('sortBy')) && !deepEqual(monetateDetails, tempMonetateDetailsRef.current)){
            console.log('inside second section...');
            if(/\.co(?!m)/.test(url)){
                if(!resourceCategoryPageTypes.includes(pageType)){
                    console.log('111111');
                    setTempMonetateDetails(monetateDetails);
                setGlobalCartRows(cartRows);
                setPrevUrl(url);
                setPrevPageType(pageType);
                    // dispatch(monetateDetailsAction({}))        
 
                }else{
                    console.log('inside plp section');
                Object.entries(monetateDetails).forEach(([key, value]) => {
                    window.monetateQ.push(value);
                });
                window.monetateQ.push(["addCartRows", cartRows]);
                window.monetateQ.push(["setPageType", pageType]);
     
                window.monetateQ.push(["trackData"]);
                setTempMonetateDetails(monetateDetails);
                setGlobalCartRows(cartRows);
                setPrevUrl(url);
                setPrevPageType(pageType);
                }
            }
            else{
                console.log('3333333');
                console.log('inside plp section');
                Object.entries(monetateDetails).forEach(([key, value]) => {
                    window.monetateQ.push(value);
                });
                window.monetateQ.push(["addCartRows", cartRows]);
                window.monetateQ.push(["setPageType", pageType]);
     
                window.monetateQ.push(["trackData"]);
                setTempMonetateDetails(monetateDetails);
                setGlobalCartRows(cartRows);
                setPrevUrl(url);
                setPrevPageType(pageType);
            }
        
        // if(url.includes('.co') && !resourceCategoryPageTypes.includes(pageType)){
 
        //     }else{
        //         console.log('inside plp section');
        //         Object.entries(monetateDetails).forEach(([key, value]) => {
        //             window.monetateQ.push(value);
        //         });
        //         window.monetateQ.push(["addCartRows", cartRows]);
        //         window.monetateQ.push(["setPageType", pageType]);
     
        //         window.monetateQ.push(["trackData"]);
        //         setTempMonetateDetails(monetateDetails);
        //         setGlobalCartRows(cartRows);
        //         setPrevUrl(url);
        //         setPrevPageType(pageType);
        //     }
 
        
    }
    else if(url && pageType != 'Category_Product' && monetateDetails && !monetateDetails?.addProductDetails && (!url.includes('.pr') || url.includes('sortBy')) &&  (url.includes('product-search-results') || url.includes('content-search-results') ) && !deepEqual(monetateDetails, tempMonetateDetailsRef.current))
    {
        //search and no search
        console.log('inside search section');
        Object.entries(monetateDetails).forEach(([key, value]) => {
            window.monetateQ.push(value);
        });
        window.monetateQ.push(["addCartRows", cartRows]);
 
        window.monetateQ.push(["trackData"]);
        setGlobalCartRows(cartRows);
        setTempMonetateDetails(monetateDetails);
        setPrevUrl(url);
        setPrevPageType(pageType);
 
    }
    else if(url && pageType != 'Category_Product' && monetateDetails && ((monetateDetails?.addPurchaseRows && url.includes('/checkout/confirm')) || url.includes('/register?intl=true')) && !url.includes('.pr') &&  !url.includes('product-search-results') && !url.includes('content-search-results') )
    {
        //order confirmation
        console.log('inside order confirm section');
        if(!url.includes('/register?intl=true')){
            window.monetateQ.push(["setPageType", pageType]);
        }
        Object.entries(monetateDetails).forEach(([key, value]) => {
            window.monetateQ.push(value);
        });
        window.monetateQ.push(["addCartRows", cartRows]);
        window.monetateQ.push(["trackData"]);
        setGlobalCartRows(cartRows);
        setPrevUrl(url);
        setPrevPageType(pageType);
 
    }
    else if( url && pageType != 'Category_Product' && !url.includes('.pr') && !url.includes('.tr') && (!url.includes('.ct') || (pageType == 'Category_Main' || pageType == 'Category_Sub')) &&  !url.includes('product-search-results') && !url.includes('content-search-results') && !url.includes('/checkout/confirm') && !url.includes('/register?intl=true') )
    {
     if(pageType && (((pageType == 'Resources_Care') || (pageType == 'Resources_SDS')) && monetateDetails && !deepEqual(monetateDetails, tempMonetateDetailsRef.current))){
        console.log('same page type....');
        window.monetateQ.push(["addCartRows", cartRows]);
        // Object.entries(monetateDetails).forEach(([key, value]) => {
        //     window.monetateQ.push(value);
        // });
        if(pageType){
            window.monetateQ.push(["setPageType", pageType]);
        }
        window.monetateQ.push(["trackData"]);
        setGlobalCartRows(cartRows);
        setPrevUrl(url);
        setPrevPageType(pageType);
        setTempMonetateDetails(monetateDetails);

        }
        else if(pageType && (pageType != 'Resources_Care') && (pageType != 'Resources_SDS')) {
      
            console.log('inside general section');
            console.log('url...',url,'pageType...',pageType);
            window.monetateQ.push(["addCartRows", cartRows]);
            if(pageType){
                window.monetateQ.push(["setPageType", pageType]);
            }
            window.monetateQ.push(["trackData"]);
            setGlobalCartRows(cartRows);
            setPrevUrl(url);
            setPrevPageType(pageType);
        }else if(!pageType){
            console.log('pageType is not there....');
        //    setPrevUrl(url);
        //    setPrevPageType(pageType);
        
        }
 
    }
 
}else if(monetateDetails && monetateDetails?.addProductDetails && monetateDetails?.skuSelectEvent && deepEqual(cartRows, globalCartRowsRef.current) && !deepEqual(monetateDetails, tempMonetateDetailsRef.current)){
    //sku selection in pdp
    console.log('inside sku selection section...');
    Object.entries(monetateDetails).forEach(([key, value]) => {
        if(key != 'skuSelectEvent'){
            window.monetateQ.push(value);
        }
        if(key === "setPageType"){
            console.log('valueeee',value);
            console.log('valueeee[1]',value[1]);

            pageType = value[1];
            if(pageType){
                setPageType(pageType);
            }
        }
    });
    window.monetateQ.push(["addCartRows", cartRows]);
    window.monetateQ.push(["trackData"]);
    setGlobalCartRows(cartRows);
    setTempMonetateDetails(monetateDetails);
 
}
else if( !deepEqual(cartRows, globalCartRowsRef.current)){
    if(pageTypeRef.current){
        console.log('pageTypeRef.current...',pageTypeRef.current);
        window.monetateQ.push(["setPageType", pageTypeRef.current]);
    }
    window.monetateQ.push(["addCartRows", cartRows]);
    console.log('inside add to cart section');
    console.log('cartRows in addToCart...',cartRows);
    window.monetateQ.push(["trackData"]);
    setGlobalCartRows(cartRows);
}else if(deepEqual(cartRows, globalCartRowsRef.current)){

}
    },[state, isCartUpdate, monetateDetails])
 
 
 
function deepEqual(obj1, obj2) {
  if (obj1 === obj2) return true;
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 == null || obj2 == null) {
    return false;
  }
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) return false;
  for (let key of keys1) {
    if (!deepEqual(obj1[key], obj2[key])) return false;
  }
  return true;
}
 
    return (
        <div><p id="monetate" className='m-0'></p></div>
    )
}
export default Monetate;